export const apiUrl = 'https://maiharta.ddns.net:3098/api/';

// http://maiharta.ddns.net:3099/api/ is for dev
// https://maiharta.ddns.net:3098/api/ is for prod